import { Link } from 'react-router-dom';


import React, { useState } from "react";



import { useDesktopDropdown } from "../hooks/useDesktopDropdown";
import { useMobileMenu } from "../hooks/useMobileMenu";
import { useStickyNavbar } from "../hooks/useStickyNavbar";
import { useDataBackground } from "../hooks/useDataBackground";


import logo from '../assets/images/logo.png';


const Header = () => {
  useStickyNavbar({ navbarSelector: ".primary-navbar", progressWrapSelector: ".progress-wrap", threshold: 100 });
  useMobileMenu({ cloneDesktopIntoMobile: true });
  useDesktopDropdown({
    // defaults hi sahi match karte hain:
    // itemSelector: ".navbar__item--has-children",
    // labelSelector: ".navbar__dropdown-label",
    // submenuSelector: ".navbar__sub-menu",
    desktopMinWidth: 1200, // tumhare d-xl-* ke saath aligned
  });
  useDataBackground();

  return (






<>
  {/* ==== header start ==== */}
<header className="header">
  <div className="primary-navbar cmn-nav">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <nav className="navbar p-0">
            <div className="navbar__logo">
              <Link to="/" aria-label="go to home">
                <img src={logo} alt="logo" />
              </Link>
            </div>

            <div className="navbar__menu">
              <ul>
                <li className="navbar__item nav-fade">
                  <Link to="/">Home</Link>
                </li>

                <li className="navbar__item navbar__item--has-children nav-fade">
                  <button type="button" aria-label="dropdown menu" className="navbar__dropdown-label">
                    About
                  </button>
                  <ul className="navbar__sub-menu navbar__sub-menu--lg">
                    <li><Link to="/about">About Manikarn Digital</Link></li>
                    <li><Link to="/testimonials">Testimonials</Link></li>
                    {/*
                    <li><Link to="/our-team">Our Team</Link></li>
                    */}
                  </ul>
                </li>

                <li className="navbar__item navbar__item--has-children nav-fade">
                  <button type="button" aria-label="dropdown menu" className="navbar__dropdown-label">
                    Services
                  </button>
                  <ul className="navbar__sub-menu navbar__sub-menu--lg">
                    <li><Link to="/web-design-development">Web Design & Development</Link></li>
                    <li><Link to="/digital-marketing">Digital Marketing</Link></li>
                    <li><Link to="/graphic-designing">Graphic Designing</Link></li>
                    <li><Link to="/hosting-support">Hosting & Support</Link></li>
                  </ul>
                </li>

                <li className="navbar__item nav-fade"><Link to="/website-care">Website Care</Link></li>
                <li className="navbar__item nav-fade"><Link to="/portfolio">Portfolio</Link></li>
                <li className="navbar__item nav-fade"><Link to="/blog">Blog</Link></li>
              </ul>
            </div>

            <div className="navbar__options">
              <div className="navbar__mobile-options d-none d-sm-flex">
                <Link to="/contact" className="btn btn--secondary">
                  Contact Us
                </Link>
              </div>
              <button className="open-mobile-menu d-flex d-xl-none" aria-label="toggle mobile menu" type="button">
                <i className="fa-solid fa-bars-staggered" />
              </button>
            </div>
          </nav>
        </div>
      </div>
    </div>

    {/* ==== mobile menu start ==== */}
    <div className="mobile-menu">
      <nav className="mobile-menu__wrapper">


<div
  className="mobile-menu__header nav-fade"
  style={{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  }}
>
  <div className="logo" style={{ flex: '0 0 auto' }}>
    <Link to="/"><img src={logo} alt="logo" /></Link>
  </div>
  <button
    aria-label="close mobile menu"
    className="close-mobile-menu"
    type="button"
    style={{ flex: '0 0 auto', marginLeft: 'auto' }}
  >
    <i className="fa-solid fa-xmark"></i>
  </button>
</div>

        <div className="mobile-menu__list" />
        <div className="mobile-menu__options d-flex d-sm-none justify-content-center nav-fade" />

        <div className="mobile-menu__social social nav-fade">
          <a href="https://www.instagram.com/manikarndigital/" target="_blank" rel="noopener noreferrer" aria-label="share us on instagram">
            <i className="fa-brands fa-instagram" />
          </a>
          <a href="https://wa.me/919034050507" target="_blank" rel="noopener noreferrer" aria-label="share us on instagram">
            <i className="fa-brands fa-whatsapp" />
          </a>
        </div>
      </nav>
    </div>
    <div className="mobile-menu__backdrop" />
    {/* ==== / mobile menu end ==== */}
  
  </div>
</header>

  {/* ==== / header end ==== */}









</>












  );
};

export default Header;
